import { MEMBER_TYPES } from '@/core/const/memberTypes.const'
import type { Constructor, Field, Method, TypeDef } from '@/core/types/library.type'

import { getUnifiedGraftModelType } from './getUnifiedGraftModelType'

/**
 * Type guard: true if the value is a graft model member (TYPE_DEF, METHOD, CONSTRUCTOR, FIELD, etc.).
 */
export const isMember = (m: unknown): m is Method | Constructor | Field | TypeDef =>
  typeof m === 'object' &&
  m !== null &&
  (Object.hasOwn(m as object, 'unifiedGraftModelType') || Object.hasOwn(m as object, 'graftModelType')) &&
  MEMBER_TYPES.has(getUnifiedGraftModelType(m as { unifiedGraftModelType?: unknown; graftModelType?: unknown }))
